import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef } from "react";
export var Font;
(function (Font) {
    Font[Font["Inter"] = 0] = "Inter";
})(Font || (Font = {}));
export const FONT = {
    [Font.Inter]: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif'
};
export var FontWeight;
(function (FontWeight) {
    FontWeight[FontWeight["Thin"] = 100] = "Thin";
    FontWeight[FontWeight["ExtraLight"] = 200] = "ExtraLight";
    FontWeight[FontWeight["Light"] = 300] = "Light";
    FontWeight[FontWeight["Normal"] = 400] = "Normal";
    FontWeight[FontWeight["Medium"] = 500] = "Medium";
    FontWeight[FontWeight["SemiBold"] = 600] = "SemiBold";
    FontWeight[FontWeight["Bold"] = 700] = "Bold";
    FontWeight[FontWeight["ExtraBold"] = 800] = "ExtraBold";
    FontWeight[FontWeight["Heavy"] = 900] = "Heavy";
})(FontWeight || (FontWeight = {}));
export function getFontSizeString(fontSize) {
    //return `calc(${fontSize / 5}rem + ${4 * fontSize / 5}vw`;
    return `${fontSize / 16}rem`;
}
export const TextElement = (props) => {
    const { text = '', fontSize = 1, color1Length, color1 = '#ffffff', color2, fontWeight = FontWeight.Normal, letterSpacing, centered, font, alignCenter, style, apiRef, } = props;
    const actualColor1Length = useMemo(() => {
        return color1Length !== null && color1Length !== void 0 ? color1Length : text.length;
    }, [text.length, color1Length]);
    const span1Text = useMemo(() => text.substring(0, actualColor1Length), [text, actualColor1Length]);
    const span2Text = useMemo(() => text.substring(actualColor1Length), [text, actualColor1Length]);
    const letterSpacingFactor = letterSpacing !== null && letterSpacing !== void 0 ? letterSpacing : 0.04;
    const fontSizeRef = useRef(fontSize);
    const span1Ref = useRef(null);
    const span2Ref = useRef(null);
    useEffect(() => {
        if (apiRef !== undefined) {
            apiRef.current = {
                setFontSize: (fontSize) => {
                    fontSizeRef.current = fontSize;
                    if (span1Ref.current !== null) {
                        span1Ref.current.style.fontSize = getFontSizeString(fontSize);
                        span1Ref.current.style.letterSpacing = getFontSizeString(letterSpacingFactor * fontSize);
                    }
                    if (span2Ref.current !== null) {
                        span2Ref.current.style.fontSize = getFontSizeString(fontSize);
                        span2Ref.current.style.letterSpacing = getFontSizeString(letterSpacingFactor * fontSize);
                    }
                }
            };
        }
    }, [apiRef]);
    const finalFontSize = useMemo(() => {
        if (apiRef === undefined) {
            return fontSize;
        }
        return fontSizeRef.current;
    }, [apiRef, fontSize]);
    const spanStyle = useMemo(() => ({
        fontSize: getFontSizeString(finalFontSize), fontWeight: fontWeight, fontFamily: font !== undefined ? FONT[font] : undefined,
        letterSpacing: getFontSizeString(letterSpacingFactor * finalFontSize)
    }), [fontSize]);
    const span1Style = useMemo(() => (Object.assign(Object.assign({}, spanStyle), { color: color1 })), [color1, spanStyle]);
    const span2Style = useMemo(() => (Object.assign(Object.assign({}, spanStyle), { color: color2 })), [color2, spanStyle]);
    const textClass = useMemo(() => centered ? 'centeredText' : '', [centered]);
    return (_jsxs("p", { style: Object.assign({ alignSelf: alignCenter ? 'center' : undefined }, style), className: `textElement ${textClass}`, children: [_jsx("span", { ref: span1Ref, style: span1Style, children: span1Text }), _jsx("span", { ref: span2Ref, style: span2Style, children: span2Text })] }));
};
//# sourceMappingURL=TextElement.js.map